  import React, { useCallback } from 'react'
import { useDropzone } from 'react-dropzone'
import { useStore } from '../../Stores/store'
import { AiOutlineUpload } from 'react-icons/ai'

export default function PhotoUploadWidget(){
    const { managementStore } = useStore();
    const { uploadPicture } = managementStore;

    const dzBase = "flex flex-col items-center justify-center gap-2 border-2 border-dashed border-gray-300 rounded-md h-28 w-full cursor-pointer transition-colors hover:border-gray-500";
    const dzActiveClass = "flex flex-col items-center justify-center gap-2 border-2 border-dashed border-green-400 rounded-md h-28 w-full cursor-pointer";

    const onDrop = useCallback((acceptedFiles : File[]) => {
        if(acceptedFiles && acceptedFiles.length > 0){
            uploadPicture(acceptedFiles[0]);
        }
    }, [uploadPicture]);
    const {getRootProps, getInputProps, isDragActive} = useDropzone({onDrop})

    return (
        <div {...getRootProps()} className={isDragActive ? dzActiveClass : dzBase}>
          <input {...getInputProps()} />
          <AiOutlineUpload className="text-3xl text-gray-500" />
          <h4 className="text-sm text-gray-500 m-0">Upload</h4>
        </div>
      )

}
